export const trimString = (str: string, length: number): string =>
  str.slice(0, length);
